<div (click)="onViewDetails()">
  <div class="contenedor-link-detalle">
    <i class="material-icons eye-icon custom-eye">visibility</i>
    <span class="label-detalle">Detalle</span>
    <div *ngIf="mostrarBadge$ | async">
      <img src="assets/images/highlight.png" class="badge-image-custom" alt="Alerta">
    </div>
  </div>
</div>